/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Output } from '@angular/core';

import { SmartAssistantService } from '../smart-assistant.service';
import { SmartAssistantStrService } from '../smart-assistant-str.service';

@Component({
    selector: 'app-storage-resources-guidance',
    templateUrl: './storage-resources-guidance.component.html',
    styleUrls: ['./storage-resources-guidance.component.scss'],
})
export class StorageResourcesGuidanceComponent implements OnInit {
    /**
     * 从引导页回到助手首页
     */
    @Output() goBack = new EventEmitter<void>();
    /**
     * 资源发放标题
     */
    operateTitle: string;
    i18n = this.str.i18n;

    constructor(
        public str: SmartAssistantStrService,
        private service: SmartAssistantService,
    ) { }

    ngOnInit(): void {
        const { guideOperateType } = this.service.getGuideInfo();
        this.operateTitle = this.str.getOperateTypeLabel(guideOperateType);
    }

    /**
     * 回到智能助手首页
     */
    back(): void {
        this.goBack.emit();
        this.service.initStatus();
    }
}
